import React from "react";

import type { TAccessionDetail } from "@/lib/types";

type AccessionSearchContextValues = {
  search: string;
  isLoading?: boolean;
  items: TAccessionDetail[];
};
export const AccessionSearchContext = React.createContext(
  {} as AccessionSearchContextValues,
);
